import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { Breadcrumb, Input, Table, Space, Popconfirm } from "antd";
import { getRequest, postRequest } from "../../axios";
import SearchIcon from "../../image/SearchIcon.svg";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg, 
} from "../../utils/Notifications";

const { Search } = Input;

const Archivewarehouse = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const [archivedMaterialList, setArchivedMaterialList] = useState([]);
  const [archivecompanyList, setArchiveCompanyList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);

  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getMaterialArchiveList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(
          "warehouse/archived-warehouse-list/",
          state
        );

        if (apiResponse?.data?.results?.data) {
          setArchiveCompanyList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archived_material"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getMaterialArchiveList();
  }, [state, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    // if (sortField === "company_name" && sortOrder === "ascend") {
    //   sortingEnumKey = "company_name";
    // }
    // if (sortField === "company_name" && sortOrder === "descend") {
    //   sortingEnumKey = "-company_name";
    // }
    // if (sortField === "company_email" && sortOrder === "ascend") {
    //   sortingEnumKey = "company_email";
    // }
    // if (sortField === "company_email" && sortOrder === "descend") {
    //   sortingEnumKey = "-company_email";
    // }

    if (sortField === "street_address" && sortOrder === "ascend") {
      sortingEnumKey = "street_address";
    }
    if (sortField === "street_address" && sortOrder === "descend") {
      sortingEnumKey = "-street_address";
    }

    if (sortField === "additional_details" && sortOrder === "ascend") {
      sortingEnumKey = "additional_details";
    }
    if (sortField === "additional_details" && sortOrder === "descend") {
      sortingEnumKey = "-additional_details";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb";
    }

    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state";
    }
    if (sortField === "postcode" && sortOrder === "ascend") {
      sortingEnumKey = "postcode";
    }
    if (sortField === "postcode" && sortOrder === "descend") {
      sortingEnumKey = "-postcode";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("warehouse/restore-warehouse/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("warehouse_restore_successfully"));
        setSelectedRow([]);
        navigate("/warehouse");
      } else {
        ErrorNotificationMsg(t("error_in_restore_warehouse"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };
  // const openImageInNewTab = (imageSrc) => {
  //     window.open(imageSrc, "_blank");
  // };

  const columns = [
    {
      title: "Address",
      dataIndex: "street_address",
      key: "street_address",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Additional Details",
      dataIndex: "additional_details",
      key: "additional_details",
      sorter: true,
      width: 130,
    },
    {
      title: "Suburb",
      dataIndex: "suburb",
      key: "suburb",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
      ),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: true,
      width: 130,
    },

    {
      title: "Postcode",
      dataIndex: "postcode",
      key: "postcode",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 130,
      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Restore</span>}
          > */}
          <Popconfirm
            className="action"
            title={t("pop_restore_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleRestore(record.id)}
          >
            <ArchiveRestore className="ArchiverestorImg" />{" "}
          </Popconfirm>
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View details of the archived material, including description,
                  category, and supplier.
                </span>
              }
            > */}
            <h3>{t("Archive Warehouse")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/warehouse">{t("Manage Warehouse")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Archive Warehouse")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label="Restore"
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="PR-body">
          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={archivecompanyList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page", // Text for the size changer
              },
            }}
            onChange={handleTableChange}
            scroll={{ x: 1200 }}
          />
          <div className="FormFooter Container">
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("Back To List")}
              onClick={() => navigate(`/warehouse`)}
              //onClick={() => setCurrentIndex(0)}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Archivewarehouse;
